export default __webpack_public_path__ + "static/media/DB.68c3c342.jpg";